import { render, staticRenderFns } from "./newOrders.vue?vue&type=template&id=7803ed74&"
import script from "./newOrders.vue?vue&type=script&lang=js&"
export * from "./newOrders.vue?vue&type=script&lang=js&"
import style0 from "./newOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports